module.exports = {"contact_email":"afghanistanturks.ata@gmail.com","facebook_url":"https://www.facebook.com/Afghanistan-Turks-Association-UK-290059231816610"}